import { render, staticRenderFns } from "./TablaUsuarios.vue?vue&type=template&id=117a4200&scoped=true"
import script from "./TablaUsuarios.vue?vue&type=script&lang=js"
export * from "./TablaUsuarios.vue?vue&type=script&lang=js"
import style0 from "./TablaUsuarios.vue?vue&type=style&index=0&id=117a4200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117a4200",
  null
  
)

export default component.exports